<template>
  <el-container>
    <!-- <el-header>
      <el-row>
        <el-col :span="6"><img src="../assets/logo.png" class="logo"/></el-col>
        <el-col :span="12"><h1>数据集大全 ({{datasets.length}})</h1></el-col>
        <el-col :span="6"></el-col>
      </el-row>
    </el-header> -->
    <el-main>
      <el-tabs v-model="activeTab" type="border-card">
        <template v-for="domain in domains" :key="domain">
          <el-tab-pane :label="domain" :name="domain">
            <div class="toolbar">
              <h3>{{domain}}数据集 （{{filteredPageDatasets.length}}）</h3>
              <el-input v-model="search" size="mini" placeholder="输入搜索内容" :prefix-icon="Search" class="search-bar" />
              <div class="tools">
                  <el-radio-group v-model="view" size="small" v-for="item in views" :key="item.label" @change="changeView(item.label)">
                    <el-tooltip class="item" effect="dark" :content="item.label + ' 布局'" placement="bottom">
                      <el-radio-button :label="item.label"><span :class="'iconfont ' + item.icon"></span></el-radio-button>
                    </el-tooltip>
                  </el-radio-group>
              </div>
            </div>
            <br />
            <div v-if="view === 'List'" class="wrapper-content">
              <template v-for="(dataset, index) in filteredPageDatasets" :key="index">
                <el-card class="box-card" style="width: 60%; margin: auto;">
                  <div class="card-header">
                    <h4>{{ dataset.name}}</h4>
                    <div>
                      <el-space>
                        <template v-if="dataset.title !== dataset.domain">
                          <el-tooltip class="item" effect="dark" :content="labels.title"><span class="card-header-item">{{dataset.title}}</span></el-tooltip>
                          <span style="padding: 5px;"></span>
                        </template>
                        <template v-if="dataset.type !== ''">
                          <span :class="'card-header-item iconfont ' + getIcon(dataset.format)"></span>
                          <el-tooltip class="item" effect="dark" :content="labels.type"><span class="card-header-item">{{dataset.type}}</span></el-tooltip>
                          <span style="padding: 5px;"></span>
                        </template>
                        <template v-if="dataset.count !== ''">
                          <el-tooltip class="item" effect="dark" :content="labels.count"><span class="card-header-item">{{$filters.format_number(dataset.count)}}</span></el-tooltip>
                          <span style="padding: 5px;"></span>
                        </template>
                        <template v-if="dataset.size !== ''">
                          <el-tooltip class="item" effect="dark" :content="labels.size"><span class="card-header-item">{{dataset.size}}</span></el-tooltip>
                          <span style="padding: 5px;"></span>
                        </template>
                        <template v-if="dataset.link !== ''">
                          <el-link :href="getDownloadUrl(dataset.link)" type="primary" style="vertical-algin: middle;" target="_blank" >下载</el-link>
                        </template>
                      </el-space>
                    </div>            
                  </div>
                  <!-- <el-divider></el-divider> -->
                  <el-space direction="vertical" alignment="left" size="mini" style="width: 100%;">
                    <div v-if="dataset.keywords !== ''" style="display: flex;">
                      <el-tag>{{labels.keywords}}</el-tag><span style="padding: 10px;"></span><div class="card-body-item"><span>{{dataset.keywords}}</span></div>
                    </div>
                    <div v-if="dataset.scenes !== ''" style="display: flex;">
                      <el-tag>{{labels.scenes}}</el-tag><span style="padding: 10px;"></span><div class="card-body-item"><span>{{dataset.scenes}}</span></div>
                    </div>
                    <div v-if="dataset.field !== ''" style="display: flex;">
                      <el-tag>{{labels.field}}</el-tag><span style="padding: 10px;"></span><div class="card-body-item"><span>{{dataset.field}}</span></div>
                    </div>
                    <div v-if="dataset.sample !== ''" style="display: flex;">
                      <el-tag>{{labels.sample}}</el-tag><span style="padding: 10px;"></span><div class="card-body-item"><span>{{dataset.sample}}</span></div>
                    </div>
                    <div v-if="dataset.source !== ''" style="display: flex;">
                      <el-tag>{{labels.source}}</el-tag><span style="padding: 10px;"></span><div class="card-body-item"><span>{{dataset.source}}</span></div>
                    </div>
                  </el-space>
                </el-card>
                <div style="padding: 5px"></div>
              </template>
            </div>
            <div v-if="view === 'Table'" class="wrapper-content">
              <div style="padding: 10px;"></div>
              <el-scrollbar noresize>
                <div style="padding: 10px;"></div>
                <el-table :data="filteredPageDatasets" stripe border>
                  <el-table-column :prop="tableHeaders.name.prop" :label="tableHeaders.name.label" min-width="160px" sortable></el-table-column>
                  <el-table-column :prop="tableHeaders.type.prop" :label="tableHeaders.type.label" width="110px" align="center" sortable></el-table-column>
                  <!-- <el-table-column :prop="tableHeaders.title.prop" :label="tableHeaders.title.label" width="100px" align="center" sortable></el-table-column> -->
                  <el-table-column :prop="tableHeaders.format.prop" :label="tableHeaders.format.label" width="110px" align="center" sortable></el-table-column>
                  <el-table-column :prop="tableHeaders.count.prop" :label="tableHeaders.count.label" width="100px" align="right" sortable>
                    <template #default="scope">
                      <span>{{$filters.format_number(scope.row.count)}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column :prop="tableHeaders.size.prop" :label="tableHeaders.size.label" width="110px" align="right" sortable></el-table-column>
                  <el-table-column :prop="tableHeaders.keywords.prop" :label="tableHeaders.keywords.label" min-width="360px"></el-table-column>
                  <el-table-column :prop="tableHeaders.scenes.prop" :label="tableHeaders.scenes.label" width="140px"></el-table-column>
                  <el-table-column :prop="tableHeaders.field.prop" :label="tableHeaders.field.label" width="280px"></el-table-column>
                  <el-table-column :prop="tableHeaders.link.prop" :label="tableHeaders.link.label" width="80px" align="center">
                    <template #default="scope">
                      <div>
                        <templete v-if="scope.row.link !== ''">
                          <el-link
                            type="primary"
                            :href="getDownloadUrl(scope.row.link)"
                            target="_blank"
                          >
                          下载
                          </el-link>
                        </templete>
                      </div>
                    </template>
                  </el-table-column>
                  <!-- <template v-for="(item, index) in headers" :key="index">
                    <template v-if="item.prop !== 'domain'">
                      <el-table-column :prop="item.prop" :label="item.label" sortable >
                        <template #default="scope" v-if="item.prop === 'link'">
                          <div>
                            <templete v-if="scope.row.link !== ''">
                              <el-link
                                type="primary"
                                :href="getDownloadUrl(scope.row.link)"
                                target="_blank"
                              >
                              下载
                              </el-link>
                            </templete>
                          </div>
                        </template>
                      </el-table-column>
                    </template>
                  </template> -->
                </el-table>
              </el-scrollbar>
            </div>
            <div v-if="view === 'Card'" class="wrapper-content">
              <el-row>
                <el-col :span="14">
                  <div style="height: 640px;">
                    <el-scrollbar noresize>
                      <div class="grid-content domain-list">
                        <el-space wrap :size="30">
                          <template v-for="(dataset, index) in filteredPageDatasets" :key="index">
                            <el-card class="el-card dataset-card" :body-style="{ padding: '0px' }" @click="handleDatasetClick(index)">
                              <div class="datasetBg">
                                <div style="display: flex; flex-grow: 1"/>
                                <span v-if="index == activeDatasetId" :class="'dataset-icon-selected iconfont ' + getIcon(dataset.format)"></span>
                                <span v-else :class="'dataset-icon iconfont ' + getIcon(dataset.format)"></span>
                                <div style="display: flex; flex-grow: 1"/>
                              </div>
                              <div v-if="index == activeDatasetId" class="dataset-label-selected">
                                <span>{{dataset.name}}</span>
                              </div>
                              <div v-else class="dataset-label">
                                <span>{{dataset.name}}</span>
                              </div>
                            </el-card>
                          </template>
                        </el-space>
                      </div>
                    </el-scrollbar>
                  </div>
                </el-col>
                <el-col :span="10">
                  <template v-if="activeDatasetId != -1" >
                    <div class="grid-content dataset-detail wrapper-content">
                      <div style="padding: 2px"></div>
                      <el-descriptions class="margin-top description-body" border :title="filteredPageDatasets[activeDatasetId].name" :column="2">
                        <el-descriptions-item v-if="filteredPageDatasets[activeDatasetId].title !== filteredPageDatasets[activeDatasetId].domain"><template #label>{{labels.title}}</template>{{filteredPageDatasets[activeDatasetId].title}}</el-descriptions-item>
                        <el-descriptions-item v-if="filteredPageDatasets[activeDatasetId].type !== ''"><template #label>{{labels.type}}</template>{{filteredPageDatasets[activeDatasetId].type}}</el-descriptions-item>
                        <el-descriptions-item v-if="filteredPageDatasets[activeDatasetId].format !== ''"><template #label>{{labels.format}}</template><span :class="'iconfont ' + getIcon(filteredPageDatasets[activeDatasetId].format)"></span> {{filteredPageDatasets[activeDatasetId].format}}</el-descriptions-item>
                        <el-descriptions-item v-if="filteredPageDatasets[activeDatasetId].count !== ''"><template #label>{{labels.count}}</template>{{$filters.format_number(filteredPageDatasets[activeDatasetId].count)}}</el-descriptions-item>
                        <el-descriptions-item v-if="filteredPageDatasets[activeDatasetId].size !== ''"><template #label>{{labels.size}}</template>{{filteredPageDatasets[activeDatasetId].size}}</el-descriptions-item>
                        <el-descriptions-item v-if="filteredPageDatasets[activeDatasetId].fraquncy !== ''"><template #label>{{labels.fraquncy}}</template>{{filteredPageDatasets[activeDatasetId].fraquncy}}</el-descriptions-item>
                        <el-descriptions-item v-if="filteredPageDatasets[activeDatasetId].link !== ''"><template #label>{{labels.link}}</template>
                            <el-link type="primary" target="_blank" :href="getDownloadUrl(filteredPageDatasets[activeDatasetId].link)">下载</el-link>
                        </el-descriptions-item>
                        <!-- <template v-for="(item, index) in headers" :key="index">
                          <template v-if="item.prop !== 'domain' && item.prop !== 'name'">
                              <el-descriptions-item v-if="filteredPageDatasets[activeDatasetId][item.prop] !== ''">
                                <template #label>{{item.label}}</template>
                                <template v-if="item.prop === 'link'">
                                  <templete v-if="filteredPageDatasets[activeDatasetId].link !== ''">
                                    <el-link type="primary" target="_blank"
                                      :href="getDownloadUrl(filteredPageDatasets[activeDatasetId].link)"
                                    >
                                    下载
                                    </el-link>
                                  </templete>
                                </template>
                                <template v-else-if="item.prop === 'type'">
                                  <span :class="'iconfont ' + getIcon(filteredPageDatasets[activeDatasetId].type)"></span> {{filteredPageDatasets[activeDatasetId][item.prop]}}
                                </template>
                                <template v-else>
                                  {{filteredPageDatasets[activeDatasetId][item.prop]}}
                                </template>
                              </el-descriptions-item>
                          </template>
                        </template> -->
                      </el-descriptions>
                      <el-descriptions class="margin-top description-body" border :column="1">
                        <el-descriptions-item v-if="filteredPageDatasets[activeDatasetId].keywords !== ''"><template #label>{{labels.keywords}}</template>{{filteredPageDatasets[activeDatasetId].keywords}}</el-descriptions-item>
                        <el-descriptions-item v-if="filteredPageDatasets[activeDatasetId].scenes !== ''"><template #label>{{labels.scenes}}</template>{{filteredPageDatasets[activeDatasetId].scenes}}</el-descriptions-item>
                        <el-descriptions-item v-if="filteredPageDatasets[activeDatasetId].field !== ''"><template #label>{{labels.field}}</template>{{filteredPageDatasets[activeDatasetId].field}}</el-descriptions-item>
                        <el-descriptions-item v-if="filteredPageDatasets[activeDatasetId].sample !== ''"><template #label>{{labels.sample}}</template>{{filteredPageDatasets[activeDatasetId].sample}}</el-descriptions-item>
                        <el-descriptions-item v-if="filteredPageDatasets[activeDatasetId].source !== ''"><template #label>{{labels.source}}</template>{{filteredPageDatasets[activeDatasetId].source}}</el-descriptions-item>
                      </el-descriptions>
                      <div style="padding: 2px"></div>
                    </div>
                  </template>
                </el-col>
              </el-row>
            </div>
            <br />
          </el-tab-pane>
        </template>
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
// import Web_Config from '@/config'
import axios from 'axios'
import Papa from 'papaparse'
import _ from 'lodash';

export default {
  name: "Dataset",
  data() {
    return {
      view: "List",
      views: [{label: "List", icon: "icon-server"},
              {label: "Table", icon: "icon-justify"},
              {label: "Card", icon: "icon-category"}],
      activeTab: "",
      search: "",
      activeDatasetId: -1,
      datasets: [],
      pageDatasets: [], // 当前页面所有数据集
      filteredPageDatasets: [], // 筛选后的数据集
      domains: [],
      headers: [],
      tableHeaders: null,
      labels: null,
      loading: false,
    };
  },
  mounted() {
    this.fetchCSV();
  },
  watch: {
    activeTab() {
      this.updatePageDataset();
    },
    search: _.debounce(function (newValue, oldValue) {
      const filteredDatasets = this.pageDatasets.filter(
        (data) =>
          !newValue || 
          data.name.toLowerCase().includes(newValue.toLowerCase()) ||
          data.title.toLowerCase().includes(newValue.toLowerCase()) ||
          data.keywords.toLowerCase().includes(newValue.toLowerCase()) ||
          data.scenes.toLowerCase().includes(newValue.toLowerCase()) ||
          data.sample.toLowerCase().includes(newValue.toLowerCase()) ||
          data.field.toLowerCase().includes(newValue.toLowerCase())
      )
      this.filteredPageDatasets = filteredDatasets
    },100)
  },
  methods: {
    fetchCSV() {
      const loadData = this.$loading({ fullscreen: false });
      let baseURL = this.getBaseUrl();

      axios.get(baseURL + 'dataset.csv', { responseType: 'blob' })
          .then(res => {
            Papa.parse(res.data, {
              header: true,
              complete: (result) => {
                if (result.errors.length > 0) {
                  let err = result.errors[0].message;
                  console.log(err);
                  this.$message.error('获取数据失败。' + err);
                  return;
                }
      
                if (result.data.length > 0) {
                  let domain_set = new Set();
                  this.datasets = result.data;
      
                  let i = 0;
                  for (let row of this.datasets) {
                    for (let x in row) {
                      if (x === "domain" && i > 0) {
                        domain_set.add(row[x]);
                      }
                    }
                    
                    i++;
                  }
      
                  this.labels = this.datasets[0];
      
                  this.headers = [];
                  this.tableHeaders = new Object;
                  for (let item in this.labels) {
                    let domain = {'prop': item, 'label': this.labels[item]};
                    this.headers.push(domain);
                    this.tableHeaders[item] = domain;
                  }
                  this.datasets.shift();
      
                  this.domains = Array.from(domain_set);
      
                  this.activeTab = this.domains[0];
                  this.updatePageDataset();
                  // console.log(this.domains);
                  // console.log(this.datasets);
                  // console.log(this.headers);
                }
                loadData.close();
              },
            });
          })

    },
    getIcon(type) {
      if (type.toLowerCase().search("wav|mp3") >= 0)
        //音频
        return "icon-mic";
      if (type.toLowerCase().search("mp4") >= 0)
        //视频
        return "icon-video_recorder";
      if (type.toLowerCase().search("jpg|jpeg|png|bmp|tiff|tif") >= 0)
        //图片
        return "icon-image";
      if (type.toLowerCase().search("csv|json|xls|xlsx|txt|xml") >= 0)
        //文本
        return "icon-document";
      if (type.toLowerCase().search("zip|gz") >= 0)
        //其他
        return "icon-database";
      
      return "icon-file";
    },
    getDownloadUrl(file) {
      return  this.getBaseUrl() + file;
    },
    handleDatasetClick(id) {
      this.activeDatasetId = id;
    },
    updatePageDataset() {
      this.pageDatasets = [];

      for (let row of this.datasets) {
        if (row['domain'] === this.activeTab) {
          this.pageDatasets.push(row);
        }
      }

      if (this.pageDatasets.length > 0) {
        this.activeDatasetId = 0;
      }
      else {
        this.activeDatasetId = -1;
      }
      this.filteredPageDatasets = this.pageDatasets
      // console.log(this.activeDatasetId);
      // console.log(this.pageDatasets);
    },
    changeView(v) {
      if (v === 'Card')
        this.view = 'Card';
      else if (v === 'Table')
        this.view = 'Table';
      else
        this.view = 'List';
    },
    getBaseUrl() {
      let url = window.location.href;
      url = url.substring(0, url.lastIndexOf('/') + 1);

      // if (process.env.NODE_ENV === "development") {
        // url = Web_Config.baseURL;
      // }

      return url;
    },
    format_number(num) {
      value = Number(num);
      return value;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  color: #ffffff;
  text-align: center;
  font-size: 26px;
  vertical-align: middle;
}
h3 {
  color: #666;
  margin-left: 20px;
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  justify-content: flex-start;
  align-items: center;
}
.toolbar {
  background: #ccc;
  height: 60px;
  display: flex;
  justify-content: flex-start;
}
.tools {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  margin-right: 20px;
}
.el-header {
  background-color: #444;
  height: 80px;
}
.logo {
  margin: 10px;
}
.grid-content {
  border-radius: 5px;
}
.dataset-card {
  width: 220px;
  height: 200px;
  cursor: pointer;
}
.domain-list {
  margin: 0 auto;
  min-width: 720px;
}
.dataset-icon {
  display: flex;
  justify-content: center;
  align-self: center;
  color: #eee;
  font-size: 48px;
}
.dataset-icon-selected {
  display: flex;
  justify-content: center;
  align-self: center;
  color: #409eff;
  font-size: 48px;
}
.dataset-label {
  padding: 10px;
  text-align: center;
  height: 90px;
  color: #409eff;
  size: 20px;
  background-color: #eee;
}
.dataset-label-selected {
  padding: 10px;
  text-align: center;
  height: 90px;
  color: #eee;
  size: 20px;
  background-color: #409eff;
}
.dataset-detail {
  background: #f5f7fa;
  min-height: 600px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  vertical-align: middle;
}
.card-header-item {
  font-size: samll;
  align-items: center;
  vertical-align: middle;
  color: rgb(19, 151, 52)
}
.card-body-item {
  margin-top: 5px;
  width: 100%;
  font-size: small;
  border-bottom: #d9d9d9 1px solid;
}
.detail-header {
  padding: 10px;
  color: #409eff;
  font-size: large;
}
.datasetBg {
  display: flex;
  width: 220px;
  height: 124px;
  /* vite 下使用 */
  /* background: url("/src/assets/images/bg.png")
    no-repeat; */
  /* vue-cli 下使用 */
  background: url("../assets/images/bg.png")
    no-repeat;
}
.description-body {
  margin: 20px;
}

.search-bar {
  width: 200px;
  height: 50%;
  top: 33%;
  margin-right: 20px;
}
</style>
